var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',{attrs:{"header":"Authorization Error","lead":"You have attempted to display a page to which you are not authorized."}})}
var staticRenderFns = []

export { render, staticRenderFns }